import { render } from "./List.vue?vue&type=template&id=57918562&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=57918562&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-57918562"

export default script